import { Action } from '@ngrx/store';
import { OverviewDataRequest, OverviewData } from './overview.models';

export enum ActionTypes {
  LOAD_WIDGETS_DATA         = '[Overview] Load Widgets Data Action',
  LOAD_WIDGETS_DATA_SUCCESS = '[Overview] Load Widgets Data Success Action',
  LOAD_WIDGETS_DATA_FAILED  = '[Overview] Load Widgets Data Failed Action',

  RESET_WIDGETS_DATA        = '[Overview] Reset Widgets Data Action',
}

export class LoadWidgetsDataAction implements Action {
  readonly type = ActionTypes.LOAD_WIDGETS_DATA;

  public constructor(public payload: OverviewDataRequest) {
  }
}

export class LoadWidgetsDataSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_WIDGETS_DATA_SUCCESS;

  public constructor(public payload: OverviewData) {
  }
}

export class LoadWidgetsDataFailedAction implements Action {
  readonly type = ActionTypes.LOAD_WIDGETS_DATA_FAILED;

  public constructor(public payload: any) {
  }
}

export class ResetWidgetsDataAction implements Action {
  readonly type = ActionTypes.RESET_WIDGETS_DATA;
}

export type Actions =
  LoadWidgetsDataAction |
  LoadWidgetsDataSuccessAction |
  LoadWidgetsDataFailedAction |
  ResetWidgetsDataAction;
